<template>
  <main>
    <button-print-screen />
    <challenge-parent-navigation />
    <section class="container">
      <challenge-parent-controls class="mb-3" :current-child="currentChild" />
      <challenge-approve-calendar class="mb-3" :current-child="currentChild" />
      <challenge-approve-list :current-child="currentChild" />
    </section>
  </main>
</template>
<script>
import store from '@/store';

import { ButtonPrintScreen } from '@/components/general/buttons';
import ChallengeApproveCalendar from '../components/ChallengeApproveCalendar.vue';
import ChallengeParentControls from '../components/ChallengeParentControls.vue';
import ChallengeParentNavigation from '../components/ChallengeParentNavigation.vue';
import ChallengeApproveList from '../components/ChallengeApproveList.vue';

export default {
  components: {
    ChallengeParentNavigation,
    ChallengeParentControls,
    ChallengeApproveCalendar,
    ChallengeApproveList,
    ButtonPrintScreen,
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const userId = store.getters['user/getUserId'];
      const childId = to.params['childId'];
      const date = to.query.date;
      const ChallengeGoalModalPromises = [
        store.dispatch('challenge/fetchCriterionCategories'),
        store.dispatch('challenge/fetchCriterionTimeDayChoices'),
        store.dispatch('challenge/fetchCriterionTimeFrequencyChoices'),
        store.dispatch('challenge/fetchCriterionDaysOfWeek'),
        store.dispatch('challenge/fetchPredefinedCriterion'),
      ];

      await Promise.all([
        store.dispatch('parent/FetchChildrenData', userId),
        store.dispatch('challenge/fetchChildCriterionValues', { childId, date }),
        ...ChallengeGoalModalPromises,
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      next();
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      const userId = store.getters['user/getUserId'];
      const childId = to.params['childId'];
      const date = to.query.date;
      await Promise.all([
        store.dispatch('parent/FetchChildrenData', userId),
        store.dispatch('challenge/fetchChildCriterionValues', { childId, date }),
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      next();
    }
  },
  computed: {
    currentChild() {
      return this.$route.params.childId;
    },
  },
};
</script>
